export default {
    dateField: String, 
    navigator: Object
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/StockChartProps.js